// Bureau — l'espace de l'office manager : la journée en « moments »
// (arrivée, après le ménage, après le déjeuner, départ), les suivis à
// étapes (factures, fournisseurs, événements, achats, studio, tâches) et
// le stock. Vocabulaire partagé client/serveur : types de suivi, gabarits
// d'étapes et DTO.
export const BUREAU_FOLLOW_TYPES = ['FACTURE', 'FOURNISSEUR', 'EVENEMENT', 'ACHAT', 'STUDIO', 'TACHE'];
export const BUREAU_STOCK_LEVELS = ['OK', 'LOW', 'OUT'];
// Clés des points de contrôle qui se cochent seuls, à partir de ce que
// Pointage sait déjà : l'import de la veille et son arbitrage.
export const BUREAU_AUTO_KEYS = ['pointage.import', 'pointage.arbitrage'];
export const BUREAU_FOLLOW_TEMPLATES = {
    FACTURE: {
        label: 'Facture', short: 'Facture', critical: true, dateField: 'due',
        placeholder: 'Facture électricité — novembre',
        hint: 'Rappels à J-7, J-3 et le jour de l’échéance.',
        steps: [
            { label: 'Facture reçue' },
            { label: 'Transmise à la comptabilité' },
            { label: 'Paiement vérifié' },
            { label: 'Factures et justificatifs remis à la personne concernée' },
        ],
    },
    FOURNISSEUR: {
        label: 'Demande fournisseur', short: 'Fournisseur', dateField: 'none',
        placeholder: 'Imprimante pour l’accueil',
        hint: 'Échéance automatique : 2 devis et le récap le jour même, avant 17:00.',
        steps: [
            { label: 'Devis 1' },
            { label: 'Devis 2' },
            { label: 'Comparatif et récap envoyés', clearsDue: true },
            { label: 'Fournisseur validé', managerOnly: true },
            { label: 'Commande finalisée' },
        ],
    },
    EVENEMENT: {
        label: 'Événement', short: 'Événement', dateField: 'event',
        placeholder: 'Team building',
        hint: 'Échéance automatique : la proposition est due 20 jours avant la date.',
        steps: [
            { label: 'Concept' },
            { label: 'Besoins logistiques' },
            { label: 'Prestataires et tarifs' },
            { label: 'Comparaison des options' },
            { label: 'Proposition soumise à validation', clearsDue: true },
            { label: 'Proposition validée', managerOnly: true },
            { label: 'Réservations, commandes et dépenses suivies' },
        ],
    },
    ACHAT: {
        label: 'Liste d’achats', short: 'Achats', dateField: 'none',
        placeholder: '',
        hint: 'Validée par Bouchra avant d’être transmise à Aziz.',
        steps: [
            { label: 'Liste préparée' },
            { label: 'Validée par Bouchra', managerOnly: true },
            { label: 'Transmise à Aziz' },
            { label: 'Réception conforme à la liste' },
            { label: 'Rangée, stock à jour' },
        ],
    },
    STUDIO: {
        label: 'Incident studio', short: 'Studio', dateField: 'none',
        placeholder: 'Trépied cassé',
        hint: 'Bouchra est prévenue ; le suivi reste ouvert jusqu’à la réparation.',
        steps: [
            { label: 'Signalé' },
            { label: 'Décision : réparer ou remplacer', managerOnly: true },
            { label: 'Réparé ou remplacé' },
        ],
    },
    TACHE: {
        label: 'Tâche', short: 'Tâche', dateField: 'due',
        placeholder: 'Appeler le plombier',
        hint: 'Une étape par ligne si la tâche est longue.',
        steps: [{ label: 'Fait' }],
    },
};
/** Délai entre la proposition d'un événement et sa date. */
export const BUREAU_EVENT_LEAD_DAYS = 20;
/** Heure limite du récap fournisseur (même jour). */
export const BUREAU_SUPPLIER_DEADLINE = '17:00';
/** Relance puis escalade d'un moment non fait (minutes après son heure). */
export const BUREAU_NUDGE_MIN = 20;
export const BUREAU_ESCALATE_MIN = 45;
//# sourceMappingURL=bureau.js.map